// PageShell.jsx
import { Box } from "@mui/material";

export default function PageShell({ children, maxWidth = 1720 }) {
    return (
        <Box
            sx={{
                width: "100%",
                px: 4,          // padding desktop
                pt: 6,          // separacion top
                display: "flex",
                justifyContent: "center",
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    maxWidth,
                }}
            >
                {children}
            </Box>
        </Box>
    );
}